<template>
  <div class="-mx-[1.5rem] mt-[16px]">
    <b-table
      :items="dataFetcher.data"
      :fields="CREATOR_DISTRIBUTION_FIELDS"
      :empty-text="emptyTextLabel"
      responsive
      show-empty
      small
      sticky-header
      class="!max-h-[calc(100vh-330px)] !mb-0"
      :tbody-tr-class="{'hover:bg-slate-100 transition-colors duration-300 cursor-pointer': dataFetcher.data.length}"
      @row-clicked="openDrawer"
    >
      <template #cell(no)="data">
        {{ data.index + 1 }}
      </template>
      <template #cell(name)="{ item: { name, tiktok_username, status } }">
        <div class="flex flex-col gap-[10px]">
          <span class="flex items-center gap-[4px]">
            {{ name || '-' }}
            <span
              class="w-fit py-[0px] px-[10px] rounded-full border-[1px] text-[12px] font-medium rounded-full px-[4px] py-[2px] border-[1px] mb-0"
              :class="statusPillConfig(status).class"
            >{{ statusPillConfig(status).label }}</span>
          </span>
          <span class="text-[12px] text-[#828282]">{{ tiktok_username || '-' }}</span>
        </div>
      </template>
      <template #cell(category)="{ item: { category } }">
        <category-pill :category="category" />
      </template>
      <template #custom-foot>
        <td colspan="100%">
          <load-more-data
            v-if="dataFetcher"
            :fetcher="dataFetcher"
          />
        </td>
      </template>
      <template #empty="{emptyText}">
        <empty-table-card
          :fetcher="dataFetcher"
          :label="emptyText"
        />
      </template>
    </b-table>
    <member-drawer
      ref="memberDrawer"
    />
  </div>
</template>

<script>
import { createPaginatedFetcher } from '@/@core/libs/fetch/usePaginatedFetcher'
import { DAY_MONTH_YEAR } from '@/libs/filterDate'
import { CREATOR_DISTRIBUTION_FIELDS, CREATOR_STATUS_STYLE, UPGRADE_STATUS_OPTIONS } from '../config'
import MemberDrawer from '../../member/components/MemberDrawer.vue'
import LoadMoreData from '../LoadMoreData.vue'
import EmptyTableCard from '../EmptyTableCard.vue'
import CategoryPill from '../CategoryPill.vue'
import { parseAge, parsePhone, parseStatus } from '../utils'

export default {
  name: 'TableComponent',
  components: {
    MemberDrawer,
    LoadMoreData,
    EmptyTableCard,
    CategoryPill,
  },
  props: {
    filter: {
      type: Object,
      default: () => ({
        keyword: '',
        category: [],
      }),
    },
  },
  data() {
    return {
      dataFetcher: null,
      CREATOR_DISTRIBUTION_FIELDS,
      drawerData: null,
    }
  },
  computed: {
    emptyTextLabel() {
      if (this.dataFetcher.isLoading) return 'Memuat data...'
      if (this.dataFetcher.error) return 'Terdapat kesalahan saat memuat data'
      return 'Tidak ada data yang ditampilkan.'
    },
  },
  created() {
    this.initializeFetcher()
  },
  methods: {
    /** Inisialisasi paginated fetcher untuk daftar distribusi kreator */
    initializeFetcher() {
      const fnFetch = ({
        offset, limit, category, keyword, status,
      }) => this.$http_new.get('/komclass/api/v1/komlabs/creators/distribution', {
        params: {
          offset,
          limit,
          category,
          search: keyword || undefined,
          status,
        },
      }).then(res => {
        const { data: { creators, count } } = res.data
        this.$emit('set-user-count', { ...count })
        return {
          data: creators,
        }
      }).catch(() => {
        if (this.dataFetcher.offset === 0) {
          throw new Error('Gagal memuat data')
        }
        return {
          data: [],
        }
      })

      this.dataFetcher = createPaginatedFetcher(fnFetch, 0, 20)
    },
    /**
     * Reset dan muat ulang data tabel dengan filter baru
     * @param {{ category?: string[], keyword?: string, status?: string }} params
     */
    refreshData({
      category, keyword, status,
    }) {
      const finalStatus = status === 'semua' ? undefined : status
      const finalCategory = category?.length ? category.join(',') : undefined
      this.dataFetcher.fetchData({
        reset: true,
        options: {
          category: finalCategory,
          keyword,
          status: finalStatus,
        },
      })
    },
    /**
     * Konfigurasi tampilan pill status
     * @param {string} status
     * @returns {{ label: string, class: string }}
     */
    statusPillConfig(status) {
      return CREATOR_STATUS_STYLE[status.toLowerCase()] || {
        label: '',
        class: 'border-none',
      }
    },
    /**
     * Buka drawer detail kreator
     * @param {{ id: number|string }} item
     */
    openDrawer(item) {
      const mapper = data => ({
        'Data Diri': {
          Nama: data.name,
          Email: data.email,
          'No HP': parsePhone(data.phone),
          'Link Sosmed': data.tiktok_username ? `https://www.tiktok.com/@${data.tiktok_username}` : '-',
          Kategori: data.category?.join(', '),
          'Tanggal Register': DAY_MONTH_YEAR(data.register_date),
        },
        'Lain-lain': {
          'GMV 30 hari terakhir': data.gmv_30_days,
          'Jumlah Followers': data.followers_count,
          Domisili: data.domicile || '-',
          Gender: data.gender || '-',
          Usia: parseAge(data.age),
          'Tertarik menjadi anggota MCN Komlabs?': data.mcn_interest || '-',
          'Ongoing Campaign': item.ongoing_campaigns ? item.ongoing_campaigns?.join(', ') : '-',
          'Total Campaign': item.total_campaigns ? `${item.total_campaigns} Campaign` : '-',
        },
      })
      this.$refs.memberDrawer.openDrawer(item.id, mapper)
    },
  },
}
</script>
